import { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";

const PHONE = "393297452439"; // E.164 minus '+'

export default function WhatsAppButton({ message = "" }) {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  const defaultMsg =
    message ||
    "Salve! Ho visitato il vostro sito e vorrei avere maggiori informazioni sui veicoli disponibili.";
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(defaultMsg)}`;

  return (
    <>
      {/* Tooltip card */}
      {open && (
        <div
          data-testid="whatsapp-tooltip"
          className="fixed bottom-44 right-6 z-[60] max-w-[280px] animate-fade-up"
        >
          <div className="glass-strong rounded-2xl p-4 border border-[#25D366]/30 shadow-2xl">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse" />
              <div className="text-xs font-semibold text-white">
                Siamo online
              </div>
            </div>
            <p className="text-xs text-zinc-300 mb-3 leading-relaxed">
              Scrivici su WhatsApp, ti rispondiamo entro pochi minuti negli
              orari di apertura.
            </p>
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-open"
              onClick={() => setOpen(false)}
              className="block w-full text-center px-4 py-2 rounded-lg bg-[#25D366] text-black text-xs font-bold hover:bg-[#1ebe5c] transition"
            >
              Apri WhatsApp
            </a>
          </div>
        </div>
      )}

      {/* Floating button — bottom-6 */}
      <button
        data-testid="whatsapp-floating-btn"
        onClick={() => setOpen((s) => !s)}
        aria-label="Contattaci su WhatsApp"
        className="fixed bottom-24 right-6 z-[60] group"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 blur-xl group-hover:opacity-60 transition" />
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-black shadow-[0_8px_32px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform">
          <MessageCircle size={26} fill="black" />
        </span>
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
      </button>
    </>
  );
}
